import React from 'react';
import { Box, Typography, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { RequestToCallClose, RequestToCallOpen, RequestToCallWarning } from '@components';
import { LogoBcp } from '@icons';
import { useRequestContactHelper } from './requestContact.helper';
import { Anything } from '@types';

export const RequestContactPlaceholder: React.FC = () => {
	const { palette } = useTheme();
	const {
		resources,
		phone,
		isAgentOpen,
		showDisclaimer,
		indicative,
		validateClickToCallAgentOpen,
		setPhone,
		setIndicative,
		setContactToCallCountry,
		newRequestContact,
		setShowDisclaimer,
	} = useRequestContactHelper();
	return (
		<Box
			styles={{
				flexDirection: 'column',
				minHeight: '100vh',
				alignItems: 'center',
				justifyContent: 'space-around;',
			}}
		>
			<Box
				styles={{
					justifyContent: 'start',
					marginTop: rem(60),
				}}
			>
				<LogoBcp />
			</Box>

			{isAgentOpen === 'Open' && (
				<RequestToCallOpen
					phone={phone}
					indicative={indicative}
					validateClickToCallAgentOpen={validateClickToCallAgentOpen}
					setPhone={setPhone}
					setIndicative={setIndicative}
					setContactToCallCountry={setContactToCallCountry}
				/>
			)}
			{isAgentOpen === 'Closed' && <RequestToCallClose hideDisclaimer={() => setShowDisclaimer(false)} />}

			{isAgentOpen === 'ErrorToCall' && (
				<RequestToCallWarning
					newRequestContact={newRequestContact}
					tryAgainButton={() => {
						validateClickToCallAgentOpen();
					}}
				/>
			)}
			<Box
				styles={{
					width: rem(704),
					justifyContent: 'center',
					textAlign: 'center',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Box>
					{showDisclaimer && (
						<Typography
							appearance="microcopy-75-02"
							alternativeStyleProperties={{ color: palette.global.ui9 } as Anything}
						>
							{resources.disclaimer}
						</Typography>
					)}
				</Box>
			</Box>
		</Box>
	);
};
